import { useState, useEffect } from "react";
import OrderServices from "../../../services/orderServices";
import {
  CPT_SLAB_LABELS_CONFIG_KEY,
  DEFAULT_LOGISTICS_CPT_SLABS,
} from "../../../constants/logisticsCptSlabs";

export { CPT_SLAB_LABELS_CONFIG_KEY };

export interface CptSlabLevelsConfig {
  [key: string]: string;
}

export const useCptSlabLevels = () => {
  const [levels, setLevels] = useState<CptSlabLevelsConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCptSlabLevels = async () => {
      try {
        setLoading(true);
        const mobileConfigs = await OrderServices.getMobileConfig();
        let cptSlabLevels = mobileConfigs[CPT_SLAB_LABELS_CONFIG_KEY];

        if (!cptSlabLevels) {
          throw new Error("CPT Slab levels not found in mobileConfig");
        }

        cptSlabLevels = JSON.parse(cptSlabLevels);

        if (
          typeof cptSlabLevels !== "object" ||
          cptSlabLevels === null ||
          Array.isArray(cptSlabLevels)
        ) {
          throw new Error("CPT Slab levels is not an object");
        }

        setLevels(cptSlabLevels);
      } catch (err: any) {
        setError(
          err?.message || "Failed to fetch CPT Slab labels from mobileConfig"
        );
        setLevels(DEFAULT_LOGISTICS_CPT_SLABS);
      } finally {
        setLoading(false);
      }
    };

    fetchCptSlabLevels();
  }, []);

  const getLabel = (level: number): string => {
    return levels?.[level] || `Level ${level}`;
  };

  return { levels, loading, error, getLabel };
};
